module.exports = __webpack_public_path__ + "static/media/dashboard.b34cf5c1.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/dashboard.md
// module id = 1096
// module chunks = 0